import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'

const currentYear = new Date().getFullYear()

const LoginFooter = () => (
  <Paragraph className="login-footer" size="xsmall" weight="book">
    &#169; {currentYear} Camp Gladiator. All Rights Reserved.
  </Paragraph>
)

export default LoginFooter
